<script>
export default {
  name: 'Atarraya AFMS',
  components: {},
  mounted() {
    document.documentElement.setAttribute(
      'data-layout-mode',
      localStorage.getItem('layoutMode') || 'light'
    )
  }
}
</script>

<template>
  <router-view />
</template>
